import React from "react";
import Link from "gatsby-link";
import News from "../components/News"


export default({ data }) =>
<div>
    <div className="container" style={{paddingBottom: '40px'}}>
        <div className="row">
        {data.allMarkdownRemark.edges.map(({ node }) =>
                <News
                    key = {node.id}
                    desc = {node.frontmatter.desc}
                    title = {node.frontmatter.title}
                    date = {node.frontmatter.date}
                    path = {node.frontmatter.path}
                    author = {node.frontmatter.author}
                >
                {node.excerpt}
                </ News>
            )}
        </div>
    </div>
</div>


export const query = graphql `
query NewsPosts {
    allMarkdownRemark(
        sort: {fields: [frontmatter___date], order: DESC},
        filter: {fileAbsolutePath: {regex: "/(news)/.*\\.md$/"}}
        ) {
        edges {
            node {
                id
                frontmatter {
                    title
                    desc
                    date(formatString: "MMMM DD, YYYY")
                    path
                    author
                }
                excerpt(pruneLength: 280)
            }
        }
    }
}
`


// WEBPACK FOOTER //
// ./src/pages/news.js